import { all, call, put } from 'redux-saga/effects'
import { Quizzes } from 'src/graphql/Services'

import { actions } from '..'
import ApiSagas from '../api/sagas'

export default class QuizzLandingSagas {
  static *init() {
    return yield call(QuizzLandingSagas.loadQapaPage)
  }

  static *loadQapaPage() {
    const { data: result } = yield call(
      ApiSagas.query,
      Quizzes.queries.getQapaPage()
    )

    if (!result) {
      return { error: 404 }
    }

    yield put(actions.quizzLanding.setQapaPage(result))
  }

  static *loop() {
    yield all([])
  }
}
